import React from 'react'
import translations from './translations'

translations.add('en', {
    paymentTimedOut: 'Your payment has timed out. Please try again.',
    close: 'Close'
})
